import { clearTrackingEvents, setTrackingEvents } from '../../services/trackingService';
import './home.component.scss';

export default function HomeView() {
    return {
        oncreate: () => setTrackingEvents('a.target-link', 'home'),
        onremove: () => clearTrackingEvents('a.target-link'),
        view: () => (<>
            <div class="content home-content">
                <div class="content__col content__col--hero">
                    <img src="/assets/band_background.1120x1119.webp" />
                </div>
                <div class="content__col content__col--bandcamp">
                    <div class="box-border-rough bandcamp-lg">
                        <iframe style="border: 0; width: 100%; height: 42px;" src="https://bandcamp.com/EmbeddedPlayer/album=4054286118/size=small/bgcol=333333/linkcol=0f91ff/transparent=true/" seamless><a href="https://voidhunter.bandcamp.com/album/anthropocene">Anthropocene by Void Hunter</a></iframe>
                    </div>
                </div>
            </div>
        </>),
    };
}
